import React from 'react'

export const TTDK_THEME = {
  Logo: (
    <img
      src="/logo-with-text.png"
      alt="logo"
      className="d-none d-md-block"
    />
  ),
}
